<template>
  <div>
    <el-select :value="value" value-key="key" :filterable="true" :size="size" :disabled="disabled" :placeholder="placeholder" @input="change($event)" :clearable="true">
      <el-option v-for="item in options" :key="item.key" :label="item.value" :value="item.key" />
    </el-select>
  </div>
</template>

<script>
export default {
  data () {
    return {
      emptyValue: {key: 1},
      placeholder: '设备类型',
      options: [{key: 1, value: '卡'}, {key: 2, value: '设备'}]
    }
  },
  props: ['value', 'config', 'size', 'disabled', 'showAllTip', 'showAllTipLabel'],
  methods: {
    change: function (val) {
      this.$emit('input', val)
    }
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/CardTypeSelect.vue